import React from 'react';

import { ItemGroupElementHeaderWithIcon } from '../ItemGroupElement/ItemGroupElementHeaderWithIcon/ItemGroupElementHeaderWithIcon';

import './ItemGroupElementHeader.scss';

export default function ItemGroupElementHeader({ itemGroupType, itemGroupName, showHistoryButton, getAnswersHistory }) {
  return (
    <div className="eds-top-item-group">
      <ItemGroupElementHeaderWithIcon itemGroupType={itemGroupType} content={itemGroupName} />
      <div className="d-flex">
        <div className="history">
          {showHistoryButton && (
            <div className="brand-link" onClick={() => getAnswersHistory()}>
              History
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
